import React, { Component } from 'react';

export default class DropSelector extends Component {
	constructor(props){
		super(props);
		this.state={
			options:[],
			selected: null
		}
	}

	componentDidMount() {
		this.setState({
			options: this.props.options,
			selected: this.props.selected
		})
	}

	componentWillReceiveProps(nextProps) {
  		if (nextProps.selected !== this.state.selected) {
    		this.setState({ selected: nextProps.selected });
  		}
	}


	//<!---------------------------- Calling Parent Method ----------------------------!>
	onSelection(dat) {
		this.setState({
			selected: dat
		})
		this.props.selctionChange(dat);
	}	

	//<!---------------------------- Populating options ----------------------------!>
	getOptions() {
		var data = this.props.options.map((option, index) => {
			return <li className="dropdown-data" key={index} onClick={() => this.onSelection(option)}>{this.props.value?option[this.props.value]:option}</li>
		})
		return data;
	}

	render() {
		return(<div>
				<div className={"dropdown "+this.props.classes}>
					<div className="pull-right drop-arrow dropdown-toggle" data-toggle="dropdown">
						<i className="fas fa-angle-down eighteen-font"></i>
					</div>
					<div className="pull-right drop-date drop-date-wider" data-toggle="dropdown" style={{textAlign:'left'}}>
						{(this.state.selected) ? <div>{this.props.value ? this.state.selected[this.props.value] : this.state.selected}</div> : <div>{this.props.type}</div>}
					</div>
					<ul className="dropdown-menu">
				  		{this.getOptions()}
				    </ul>
				</div>
		</div>);
	}
}


// WEBPACK FOOTER //
// ./src/commons/DropSelector.js